import React,{useState} from 'react';
import { ADVANCE_VIEWER_BASE_URL } from '../../../../constants/Constants';

const IframeViewer = (props) => {

  // const [url,setUrl] = useState(process.env.REACT_APP_ADVANCEVIEWER_BASE_URL + "?study=" + window.location.pathname.substring(
  //   window.location.pathname.lastIndexOf("/") + 1
  // ));

  return (
    <>
      <iframe
        title="Meddream Viewer"
        width="100%"
        height="100%"
        src={props.meddreamFullUrl}
        allow="clipboard-read; clipboard-write; fullscreen"
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </>
  );
};

export default IframeViewer;